import useAccessRights from 'packages/hooks/useAccessRights';
import { ActiveSplits } from 'packages/store/user/types';
import useTemplateAddToCategoryModal from './useTemplateAddToCategoryModal';
import useTemplateMoveModal from './useTemplateMoveModal';

const useTemplateCategoryModal = (params: { isOverview?: boolean }) => {
    const { isSplitEnabled } = useAccessRights();
    const isMultipleCategoriesEnabled = isSplitEnabled(ActiveSplits.studioMultipleTemplateCategories);
    const moveModal = useTemplateMoveModal(params);
    const addModal = useTemplateAddToCategoryModal(params);

    return isMultipleCategoriesEnabled ? addModal : moveModal;
};

export default useTemplateCategoryModal;
